export default {
  title: 'Lista obecności',
  type: 'object',
  properties: {
    date: {
      title: 'schema.presence.date',
      type: 'string',
      format: 'date',
      fieldRequired: true
    },
    hour: {
      title: 'schema.presence.hour',
      type: 'number',
      fieldRequired: true
    },
    minute: {
      title: 'schema.presence.minute',
      type: 'number',
      fieldRequired: true
    },
    scheduleContainerId: {
      title: 'schema.presence.scheduleContainerId',
      type: 'number',
      fieldRequired: true
    },
    presentPlayersIds: {
      title: 'schema.presence.presentPlayersIds',
      type: 'array',
      items: {
        type: 'number'
      },
      minItems: 0,
      fieldRequired: true
    },
    description: {
      title: 'schema.presence.description',
      type: 'string',
      fieldRequired: false
    }
  }
};
